<template>
  <div class>
    <AppPaginaTitulo titulo="Buscar Estudos" descricao="Busque estudos no servidor WBSPACS" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card mb-4 shadow-sm">
            <div class="card-body">
              <b-form>
                <AppFormCabecalho
                  titulo="Filtros da Busca"
                  icon="mdi mdi-folder-search"
                  :classe="minimizarClass"
                >
                  <template slot="actions">
                    <b-button variant="outline-default" @click="minimizar = !minimizar">
                      {{ minimizarTexto }}
                      <i :class="minimizarIcon" class="mdi"></i>
                    </b-button>
                  </template>
                </AppFormCabecalho>
                <transition enter-active-class="animated fadeIn">
                  <div v-if="!minimizar">
                    <b-form-row>
                      <b-form-group
                        id="exampleInputGroup3"
                        class="col-sm-12 col-lg-3"
                        label="Data do Estudo"
                        label-for="exampleInput3"
                      >
                        <date-picker
                          v-model="busca.data"
                          lang="pt-br"
                          :clearable="false"
                          range
                          format="DD/MM/YYYY"
                          :shortcuts="dpConfig.shortcuts"
                          width="100%"
                          input-class="form-control form-control-sm"
                        ></date-picker>
                      </b-form-group>
                      <b-form-group
                        id="modalidade"
                        class="col-sm-12 col-lg-3"
                        label="Modalidade"
                        label-for="exampleInput3"
                      >
                        <b-form-select v-model="busca.modalidade" size="sm">
                          <template slot="first">
                            <option value>-- Selecione --</option>
                          </template>
                          <option
                            v-for="(tipo, index) in modalidades"
                            :key="index"
                            :value="tipo.name"
                          >{{ tipo.name }} - {{ tipo.descricao }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-form-row>
                    <b-form-row>
                      <b-form-group label="Nome do Paciente" label-for="nome" class="col col-lg-5">
                        <b-form-input
                          type="text"
                          id="nome"
                          size="sm"
                          v-model="busca.nome"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group label="Paciente ID" label-for="pacienteID" class="col col-lg-2">
                        <b-form-input
                          type="text"
                          id="pacienteID"
                          size="sm"
                          v-model="busca.pacienteID"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Núm. de Acesso"
                        label-for="numeroAcesso"
                        class="col-sm-12 col-lg-2"
                      >
                        <b-form-input
                          type="text"
                          id="numeroAcesso"
                          size="sm"
                          v-model="busca.numeroAcesso"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                    </b-form-row>
                    <b-button variant="success" @click="buscarEstudos">
                      <i class="mdi mdi-magnify"></i> Buscar Estudo
                    </b-button>
                  </div>
                </transition>
              </b-form>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-body">
              <EstudoTable :estudos="estudos" :loading-busca="loadingBusca" @ultima-busca="realizarUltimaBusca" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BuscarEstudoApi from "../api/buscarEstudoApi";
import DatePicker from "vue2-datepicker";
import moment from "moment";

import AppPaginaTitulo from "../components/layout/AppPaginaTitulo.vue";
import AppFormCabecalho from "../components/layout/AppFormCabecalho.vue";
import EstudoTable from "../components/estudo/EstudoTable.vue";

export default {
  name: "buscar-estudo",
  components: {
    AppPaginaTitulo,
    AppFormCabecalho,
    EstudoTable,
    DatePicker
  },
  data() {
    return {
      busca: {
        data: [new Date(), new Date()],
        servidor: "",
        modalidade: "",
        nome: "",
        pacienteID: "",
        numeroAcesso: ""
      },
      ultimaBusca: {},
      servidores: [],
      modalidades: [
        { name: "CR", descricao: "Raio X" },
        { name: "CT", descricao: "Tomografia Computadorizada" },
        { name: "MG", descricao: "Mamografia" },
        { name: "XA", descricao: "Angiografia de Raios-X" },
        { name: "NM", descricao: "Medicina Nuclear" },
        { name: "DG", descricao: "Endoscopia Digestiva" },
        { name: "PT", descricao: "Pet" },
        { name: "MR", descricao: "Ressonância Magnética" },
        { name: "OT", descricao: "Outros" },
        { name: "US", descricao: "Ultrassonografia" },
        { name: "DX", descricao: "Raio X Digital" },
        { name: "ES", descricao: "Endoscopia" },
        { name: "EC", descricao: "Ecocardiografia" },
        { name: "ECG", descricao: "Eletrocardiografia" },
        { name: "BMD", descricao: "Densitometria Óssea" }
      ],
      paginaAtual: 1,
      minimizar: false,
      loadingBusca: false,
      estudos: [],
      dpConfig: {
        shortcuts: [
          {
            text: "Hoje",
            onClick: () => {
              this.busca.data = [new Date(), new Date()];
            }
          },
          {
            text: "Ontem",
            onClick: () => {
              this.busca.data = [
                moment().subtract(1, "day"),
                moment().subtract(1, "day")
              ];
            }
          },
          {
            text: "Última semana",
            onClick: () => {
              this.busca.data = [
                moment()
                  .subtract(1, "weeks")
                  .startOf("week"),
                moment()
                  .subtract(1, "weeks")
                  .endOf("week")
              ];
            }
          },
          {
            text: "Último mês",
            onClick: () => {
              this.busca.data = [
                moment()
                  .subtract(1, "months")
                  .startOf("month"),
                moment()
                  .subtract(1, "months")
                  .endOf("month")
              ];
            }
          },
          {
            text: "Mês atual",
            onClick: () => {
              this.busca.data = [
                moment().startOf("month"),
                moment().endOf("month")
              ];
            }
          }
        ]
      },
      watchUnidadeFn: null
    };
  },
  computed: {
    minimizarTexto() {
      return this.minimizar ? "mostrar" : "minimizar";
    },
    minimizarIcon() {
      return this.minimizar ? "mdi-chevron-down" : "mdi-chevron-up";
    },
    minimizarClass() {
      return this.minimizar ? "mb-0" : "";
    }
  },
  created() {},
  methods: {
    buscarEstudos() {
      this.loadingBusca = true;
      this.ultimaBusca = this.busca;
      BuscarEstudoApi.buscar(this.busca)
        .then(resp => {
          this.estudos = resp.data;
          this.loadingBusca = false;
          if (resp.data.length == 0) {
            this.$notify({
              group: "geral",
              type: "info",
              title: "Ops!",
              text: "Nenhum estudo encontrado. Verifique os filtros da busca!"
            });
          }
        })
        .catch(() => {
          this.estudos = [];
          this.loadingBusca = false;
        });
    },
    realizarUltimaBusca(){
      this.busca = this.ultimaBusca;
      this.buscarEstudos();
    }
  }
};
</script>
